import { Component, OnInit, Input } from '@angular/core';
import { Onglet } from '../../../z16pro/classes/onglet';
import { ILanguage } from '../../../core/services/language.service';
import { Z16ProLayout } from '../../../z16pro/classes/z16ProLayout';
import { Champ } from '../../../z16pro/classes/champ';
import { Section } from '../../../z16pro/classes/section';

@Component({
  selector: 'app-z16pro-onglet-personnalise',
  templateUrl: './z16pro-onglet-personnalise.component.html',
  styleUrls: ['./z16pro-onglet-personnalise.component.css']
})
export class Z16proOngletPersonnaliseComponent implements OnInit {

    @Input() layout: Z16ProLayout;
    @Input() onglet: Onglet;
    @Input() currentLanguage: ILanguage;
    @Input() businessEntiteId?: string;
    @Input() resource: string;

    sections: Array<Section> = [];

    constructor() {
        
     }

    ngOnInit() {
        this.sections = this.layout.onglets.find(ong => ong.id === this.onglet.id).sections;
    }

    getChampsByColonne(colonne: number) {
        const champsOnglets = this.layout.getFilteredChampsOnglets(champOnglet => {
            return champOnglet.ongletId === this.onglet.id && champOnglet.colonne === colonne  && champOnglet.secId === null;
        });

        return champsOnglets.map(champOnglet => champOnglet.champ);
    }

    getChampsByColonneBySection(colonne: number, section: string){
        const champsOnglets = this.layout.getFilteredChampsOnglets(champOnglet => {
            return champOnglet.ongletId === this.onglet.id && champOnglet.colonne === colonne  && champOnglet.secId === section;
        });

        return champsOnglets.map(champOnglet => champOnglet.champ);
    }


    getChampValue(champ: Champ) {
        const entiteDonnee = this.layout.getEntiteDonneeByChamp(champ.id);

        if (entiteDonnee == null) {
            return null;
        }

        return entiteDonnee.valeur;
    }

    onValueChanged(champ: Champ, valeur: string) {
        this.layout.setDonnee(champ, valeur, this.businessEntiteId);
    }

}
